// app/javascript/turbo_streams/toast.js
import { StreamActions } from "@hotwired/turbo"
import Toastify from "toastify-js"

StreamActions.toast = function() {
  const message = this.getAttribute("message")
  const position = this.getAttribute("position") || "right"
  Toastify({
    text: message,
    duration: 3000,
    destination: "",
    close: true,
    gravity: "top",
    position: position,
    stopOnFocus: true,
    className: "custom-toast"
  }).showToast()
}


export function showToast(message) {
  const fakeElement = {
    getAttribute(attr) {
      if (attr === "message") return message;
    }
  };
  StreamActions.toast.call(fakeElement);
}